import Vue from 'vue'
import {api} from '../resources'

export default {
    namespaced: true,
    state: {
        main_chart_selected_point: null,
        structure_group_selected_point: null,
        chart_data: {
            dirty: true,
            dirty_date: true,
            expenseDynamics: {},
            expenseStructureCategory: {},
            expenseStructureGroup: {},
        },
        chart_data_in_point: {
            dirty: false,
            expenseDynamics: {},
            expenseStructureCategory: {},
            expenseStructureGroup: {},
        },
        transactions: {
            data: [],
            totals_data: {},
            dirty: true
        },
        pagination: {
            current_page: 1,
            pages: null
        }
    },
    getters: {
        timelineLineChartData: (state) => (expensesStructure) => {
            // console.table(state.chart_data.expenseDynamics.data)
            return {
                labels: state.chart_data.expenseDynamics.labels,
                datasets: state.chart_data.expenseDynamics.data.map((item, index, arr) => {
                    return {
                        label: item.label,
                        data: item.data,
                        fill: index === 0 ? true : index - 1,
                        borderWidth: 2,
                        backgroundColor: expensesStructure.value === 'all' ?
                                `rgba(242, 82, 111, 0.3)`
                            : `hsla(${parseInt(360 / arr.length * (index + 1))},100%,65%,.3)`,
                        borderColor: expensesStructure.value === 'all' ?
                                `#F2526F`
                            : `hsl(${parseInt(360 / arr.length * (index + 1))},100%,65%)`,
                        pointBackgroundColor: item.data.map((item, i) => {
                            if (expensesStructure.value === 'all') {
                                return i === state.main_chart_selected_point ? '#9d3547' : `#F2526F`
                            } else {
                                return `hsl(${parseInt(360 / arr.length * (index + 1))},100%,65%)`
                            }
                        }),
                        pointBorderColor: item.data.map((item, i) => {
                            if (expensesStructure.value === 'all') {
                                return i === state.main_chart_selected_point ? '#9d3547' : `#F2526F`
                            } else {
                                return `hsl(${parseInt(360 / arr.length * (index + 1))},100%,65%)`
                            }
                        }),
                        pointRadius: item.data.map((item, i) => i === state.main_chart_selected_point ? 5 : 3),
                        pointHoverRadius: 7,
                    }
                })
            }
        },
        timelineBarChartData: (state) => (expensesStructure) => {
            return {
                labels: state.chart_data.expenseDynamics.labels,
                datasets: state.chart_data.expenseDynamics.data.map((item, index, arr) => {
                    return {
                        label: item.label,
                        data: item.data,
                        backgroundColor: item.data.map((item, i) => {
                            if (expensesStructure.value === 'all') {
                                return i === state.main_chart_selected_point ? '#9d3547' : '#F2526F'
                            } else {
                                return i === state.main_chart_selected_point ?
                                    `hsla(${parseInt(360 / arr.length * (index + 1))},100%,65%,.95)`
                                    : `hsla(${parseInt(360 / arr.length * (index + 1))},100%,65%,.6)`
                            }
                        }),
                        hoverBackgroundColor: item.data.map((item, i) => {
                            if (expensesStructure.value === 'all') {
                                return '#9d3547'
                            } else {
                                return `hsla(${parseInt(360 / arr.length * (index + 1))},100%,65%,.7)`;
                            }
                        }),
                    }
                })
            }
        },
        doughnutChartStructureGroupData: (state) => {
            const data = !!state.main_chart_selected_point ?
                {...state.chart_data_in_point.expenseStructureGroup} :
                {...state.chart_data.expenseStructureGroup},
                active_index = state.structure_group_selected_point;
            return {
                labels: Object.keys(data).map(item => data[item].title),
                datasets: [
                    {
                        backgroundColor: Object.keys(data).map((item, i, arr) => `hsl(${parseInt(360 / arr.length * (i + 1))},100%,65%)`),
                        data: Object.keys(data).map(item => data[item].sum),
                        hoverBorderWidth: 0,
                        pie_offset: Object.keys(data).map((item, i) => i === active_index ? 12 : 0),
                    },
                ]
            }
        },
        doughnutChartStructureCategoryData: (state, getters) => {
            // console.table(state.chart_data.expenseStructureCategory)
            const data = !!state.main_chart_selected_point ?
                {...state.chart_data_in_point.expenseStructureCategory}
                : {...state.chart_data.expenseStructureCategory},
                active_group_id = getters.selected_chart_group_id;

            let data_filtered = Object.keys(data).map(item => data[item]);

            if (active_group_id !== null) {
                data_filtered = data_filtered.filter(i => i.group_id === active_group_id)
            }

            return {
                labels: data_filtered.map(item => item.title),
                datasets: [
                    {
                        backgroundColor: data_filtered.map((item, i, arr) => `hsl(${parseInt(360 / arr.length * (i + 1))},100%,65%)`),
                        data: data_filtered.map(item => item.sum),
                        hoverBorderWidth: 0
                    }
                ]
            }
        },
        selected_chart_group_id: (state) => {
            const selected_index = state.structure_group_selected_point,
                chart_data = state.main_chart_selected_point ?
                    {...state.chart_data_in_point.expenseStructureGroup}
                    : {...state.chart_data.expenseStructureGroup};
            if (selected_index !== null) {
                return chart_data[selected_index].id
            } else {
                return null;
            }
        },
        selected_point_date_range: (state) => (groupBy) => {
            if (state.main_chart_selected_point !== null) {
                //check the date
                let date = state.chart_data.expenseDynamics.labels[state.main_chart_selected_point];
                //get the moment type range
                switch (groupBy.value) {
                    case 'year':
                        return {
                            start: Vue.prototype.$moment(date, 'YYYY').startOf('year'),
                            end: Vue.prototype.$moment(date, 'YYYY').endOf('year')
                        };
                    case 'quarter':
                        return {
                            start: Vue.prototype.$moment(date, 'Q YYYY').startOf('quarter'),
                            end: Vue.prototype.$moment(date, 'Q YYYY').endOf('quarter')
                        };
                    case 'month':
                        return {
                            start: Vue.prototype.$moment(date, 'MM.YYYY').startOf('month'),
                            end: Vue.prototype.$moment(date, 'MM.YYYY').endOf('month')
                        };
                    case 'week':
                        return {
                            start: Vue.prototype.$moment(date, 'DD.MM.YYYY').startOf('week'),
                            end: Vue.prototype.$moment(date, 'DD.MM.YYYY').endOf('week')
                        };
                    case 'day':
                        return {
                            start: Vue.prototype.$moment(date, 'DD.MM.YYYY').startOf('day'),
                            end: Vue.prototype.$moment(date, 'DD.MM.YYYY').endOf('day')
                        };
                }
            } else {
                return null
            }
        },
        transactionsByDate: state => {
            const transactionsByDate = {}
            state.transactions.data.forEach(item => {
                const date = Vue.prototype.$moment.unix(item.date).startOf('day').format('DD-MM-YYYY');
                if (!transactionsByDate[date]) {
                    transactionsByDate[date] = []
                }
                transactionsByDate[date].push(item);
            })
            return transactionsByDate;
        }
    },
    actions: {
        async fetchReportData({commit, state, rootState}, dirty_date = false) {
            if (!rootState.reports.report_filters.filters.date.end) return
            commit('setDirty', dirty_date);
            commit('setChartPoint', null);

            try {
                const {filters} = rootState.reports.report_filters;
                let reportFilters = {
                        space_id: rootState.space.current_space.data.id,
                        group_by: filters.group_by.value,
                        date_start: filters.date.start,
                        date_end: filters.date.end,
                        structure: filters.expense_structure.value,
                        timezone: Vue.prototype.$moment.tz.guess()
                    },
                    transactions_search_params = {
                        space_id: rootState.space.current_space.data.id,
                        date_start: Vue.prototype.$moment(filters.date.start, 'YYYY-MM-DD').unix(),
                        date_end: Vue.prototype.$moment(filters.date.end, 'YYYY-MM-DD').endOf('day').unix(),
                        off_report: 0,
                        is_expense: 1,
                        page: state.pagination.current_page,
                        timezone: Vue.prototype.$moment.tz.guess()
                    }
                if (filters.expense_structure.value === 'category' && filters.expense_category.id !== 'all') {
                    reportFilters.expense_category_id = filters.expense_category.id;
                    transactions_search_params.expense_category_id = filters.expense_category.id;
                }
                if (filters.expense_structure.value === 'group' && filters.expense_group.id !== 'all') {
                    reportFilters.expense_group_id = filters.expense_group.id;
                    transactions_search_params.expense_group_id = filters.expense_group.id;
                }

                const report_response = await api.report_expense.save(reportFilters);
                const transactions = await api.transactions.get(transactions_search_params)
                commit('setData', {report: report_response.body.data, transactions: transactions.body});
            } catch (e) {
                console.log(e)
            }
        },
        async getChartPointData({commit, state, getters, rootState}) {
            if (!state.main_chart_selected_point) return;
            commit('setPointDataDirty');

            const {filters} = rootState.reports.report_filters,
                report_filters = {
                    space_id: rootState.space.current_space.data.id,
                    group_by: filters.group_by.value,
                    date_start: Vue.prototype.$moment(getters.selected_point_date_range(filters.group_by).start).format('YYYY-MM-DD'),
                    date_end: Vue.prototype.$moment(getters.selected_point_date_range(filters.group_by).end).endOf('day').format('YYYY-MM-DD'),
                    structure: filters.expense_structure.value
                };
            const report_response = await api.report_expense.save(report_filters);
            commit('setPointData', report_response.body.data);
        },
        async fetchTransactions({commit, state, getters, rootState}) {
            commit('setTransactionsDirty');
            try {
                const {filters} = rootState.reports.report_filters;
                const transactions_search_params = {
                    space_id: rootState.space.current_space.data.id,
                    date_start: Vue.prototype.$moment(filters.date.start, 'YYYY-MM-DD').unix(),
                    date_end: Vue.prototype.$moment(filters.date.end, 'YYYY-MM-DD').endOf('day').unix(),
                    is_expense: 1,
                    off_report: 0,
                    page: state.pagination.current_page
                }
                if (!!state.main_chart_selected_point) {
                    transactions_search_params.date_start = Vue.prototype.$moment(getters.selected_point_date_range(filters.group_by).start).unix()
                    transactions_search_params.date_end = Vue.prototype.$moment(getters.selected_point_date_range(filters.group_by).end).endOf('day').unix()
                }
                if (filters.expense_structure.value === 'category' && filters.expense_category.id !== 'all') {
                    transactions_search_params.expense_category_id = filters.expense_category.id;
                }
                if (filters.expense_structure.value === 'group' && filters.expense_group.id !== 'all') {
                    transactions_search_params.expense_group_id = filters.expense_group.id;
                }
                const transactions = await api.transactions.get(transactions_search_params)
                commit('setTransactions', transactions.body);
            } catch (e) {
                console.log(e)
            }
        }
    },
    mutations: {
        updateFilter(state, payload) {
            state.filters[payload.name] = payload.value;
        },
        clearFilters(state) {
            state.filters.structure = {value: 'all', name_en: 'All expenses', name_ru: 'Все расходы'};
        },

        setChartPoint(state, payload) {
            state.structure_group_selected_point = null;
            if (payload === state.main_chart_selected_point) {
                state.main_chart_selected_point = null;
            } else {
                state.main_chart_selected_point = payload;
            }
        },
        setPointDataDirty(state) {
            state.chart_data_in_point.dirty = true;
        },
        setPointData(state, payload) {
            state.chart_data_in_point = payload;
            state.chart_data_in_point.dirty = false;
        },
        setMainChartType(state, payload) {
            state.main_chart_type = payload;
        },
        selectChartStructureGroup(state, payload) {
            if (payload === state.structure_group_selected_point) {
                state.structure_group_selected_point = null;
            } else {
                state.structure_group_selected_point = payload;
            }
        },
        setDirty(state, dirty_date) {
            state.chart_data.dirty = true;
            state.chart_data.dirty_date = dirty_date;
            state.transactions.dirty = true;
        },
        setData(state, payload) {
            state.transactions.data = payload.transactions.data.rows;
            state.transactions.total_data = {
                total: payload.transactions.data.total,
                totalExpense: payload.transactions.data.totalExpense,
                totalIncome: payload.transactions.data.totalIncome,
                totalTransfers: payload.transactions.data.totalTransfers
            };
            state.pagination.pages = Math.ceil(payload.transactions.data.length / 20);
            state.chart_data.dirty = false;
            state.transactions.dirty = false;

            state.chart_data.expenseDynamics = payload.report.expenseDynamics;
            state.chart_data.expenseStructureCategory = payload.report.expenseStructureCategory;
            state.chart_data.expenseStructureGroup = payload.report.expenseStructureGroup;
            state.main_chart_selected_point = null;
        },
        setTransactionsDirty(state) {
            state.transactions.dirty = true;
        },
        setTransactions(state, payload) {
            state.transactions.data = payload.data.rows;
            state.transactions.total_data = {
                total: payload.data.total,
                totalExpense: payload.data.totalExpense,
                totalIncome: payload.data.totalIncome,
                totalTransfers: payload.data.totalTransfers
            };
            state.pagination.pages = Math.ceil(payload.data.length / 20);
            state.transactions.dirty = false;
        },
        setPage(state, num) {
            state.pagination.current_page = num;
        },
        resetPagination(state) {
            state.pagination = {current_page: 1, pages: null}
        },
    }
}